module.exports = __webpack_public_path__ + "static/img/true2.70dd20c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/true2.jpg
// module id = IUYj
// module chunks = 1